// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"45787487","239":"2af2eb63","455":"1098318e"}[chunkId] + ".chunk.js";
};